module.exports = __webpack_public_path__ + "static/media/criteria-not-found-m.d075e762.svg";